// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2_XcZ","colCheckbox":"styles_colCheckbox__3XXf7"};